import {gsap} from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import App from "../../App/App";
import Scroller from "../../Scroller/Scroller";

gsap.registerPlugin(ScrollToPlugin);

const FormStepperSlider = {

    init(el) {
        this.el = el;
    },

    prepare() {
        this.el.slides.each((i, el) => {
            const order = $(el).attr('order');
            this.el.tabs.filter('[order="' + order + '"]').appendTo(this.el.el.find('header'));
        })
        this.el.slides.filter('.active').find('footer').appendTo(this.el.el);
    },

    onLoad() {
        this.el.active = $(this.el.slides[0]).addClass('active');
        this.el.el.find('.tab').first().addClass('active');
        gsap.set(this.el.active, {x: 0});

        if (this.el.adaptiveHeight) {
            this.el.setHeight();
        }

        if (this.el.config.useRouter) {
            // this.el.footer.appendTo($(this.el.slides[0]).find('.content'));
        } else {

            // this.el.footer.appendTo(this.el.active.find('.content'));
        }
    },

    show(nmb) {
        const tab = this.el.tabs.filter('[order="' + nmb + '"]');
        if (tab.is('.active')) return;

        this.el.current = parseInt(tab.attr('order'));
        this.el.active = this.el.slides.filter('[order="' + this.el.current + '"]');
        const old = this.el.slides.filter('.active').attr('order');
        const direction = old < this.el.active.attr('order') ? 1 : -1;

        tab.addClass('active');
        this.el.active.addClass('active');

        gsap.fromTo(this.el.active, {
            x: 110 * direction + "%"
        }, {
            x: "0%", duration: 1, ease: "power3.out"
        })

        this.hide(old, direction);
        // this.scroll();
        this.el.arrangeButtons();
        if (this.el.adaptiveHeight) {
            this.resize();
        }
    },

    hide(nmb, direction) {
        const content = this.el.slides.filter('[order="' + nmb + '"]');
        const tab = this.el.tabs.filter('[order="' + nmb + '"]');
        tab.removeClass('active');
        content.removeClass('active');

        gsap.fromTo(content, {
                x: '0%'
            },
            {
                x: -110 * direction + "%", duration: 0.95, ease: "power3.out",
            })
    },

    scroll() {
        if (!App.isMobile) return;
        const y = this.el.el.offset().top;

        gsap.to(window, {
            duration: Scroller.animTime,
            scrollTo: {y: y, offsetY: Scroller.yOffset},
        });
    },

    resize() {

        const footerHeight = this.el.footer.outerHeight();
        const activeHeight = this.el.active.outerHeight();

        if (this.el.adaptiveHeight) {
            // gsap.set(this.el.main, {height: activeHeight})
            gsap.set(this.el.el, {height: activeHeight + footerHeight + 16})
            if(this.el.parent) gsap.set(this.el.parent, {height: activeHeight + footerHeight + 16})
        } else {
            let height = 0;
            this.el.slides.each((i, el) => {
                height = Math.max(height, $(el).outerHeight())
            })

            gsap.set(this.el.main, {height: height})
            gsap.set(this.el.el, {height: height + footerHeight + 16})
            if(this.el.parent) gsap.set(this.el.parent, {height: height + footerHeight + 16})
        }

        gsap.set(this.el.slides, {x: "110%", height: ''});
        gsap.set(this.el.active, {x: 0});
    },
}

export default FormStepperSlider;